const alertMes = (res, _this, text, isRefresh) => {
  if (res.data.status) {
    _this.$Message["success"]({
      background: true,
      content: res.data.msg
    });
    _this.current = _this.searchFrom.page = 1;
    _this.searchFrom.pageSize = 15;
    _this.isshowModal = false;
    if (isRefresh) {
      return;
    }
    if (text) {
      _this.SearchSubmit();
      return;
    }
    _this.$refs["common"].SearchSubmit();
  } else {
    _this.$Message["error"]({
      background: true,
      content: res.data.msg,
      duration: 5
    });
  }
};
export default {
  alertMes
};
